import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Switch,
  TableCell,
  TableRow,
} from "@mui/material";
import { Colors } from "../../constants/Colors";
import Card from "../../components/Card";
import CustomTable from "../../components/Table";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { apiRequest } from "../../services/api-request";
import Add from "./add";
import Pagination from "../../components/Pagination";
import { useAppContext } from "../../context/AppContext";
import CustomDialog from "../../components/ConfirmationModal";
import { downloadFile } from "../../utilities/exportToCsv";

const label = { inputProps: { "aria-label": "switch" } };

const dashboardHeader = [
  {
    id: 1,
    title: "ID",
  },
  {
    id: 2,
    title: "Name",
  },
  {
    id: 3,
    title: "Circle Name",
  },
  {
    id: 4,
    title: "Active",
  },
  {
    id: 5,
    title: "Actions",
  },
];

const View = () => {
  const { user } = useAppContext();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [list, setList] = useState({
    result: [],
    totalCount: "",
    loader: false,
  });

  const limit = 10;
  const [skip, setSkip] = useState(0);

  const [currentList, setCurrentList] = useState({});

  const [openDeleteModal, setOpenDeleteModal] = useState({
    open: false,
    data: [],
  });

  const [updateStatus, setUpdateStatus] = useState({
    open: false,
    data: {},
  });

  const [deleteRec, setDelete] = useState({
    data: {},
    open: false,
  });

  const [listCSV, setListCSV] = useState({
    data: [],
  });

  useEffect(() => {
    getLists({ skip, searchText: "" });
  }, [skip]);

  const getLists = ({ skip, searchText }) => {
    setList({ loader: true });
    const payload = {
      skip: skip,
      limit: limit,
      ...(searchText && {
        searchText: searchText,
      }),
    };

    let search = searchText ? searchText : ''
    apiRequest({
      url: "master/get-regional-office?search="+search,
      method: "GET",
      data: payload,
    })
      .then((res) => {
        setList({
          loader: false,
          totalCount: res.total_count ? res.total_count : res.data.length,
          result: res.data,
        });
      })
      .catch((err) => {
        setList({ loader: false });
      });
  };

  const handlePageChange = (pageNumber) => {
    const newSkip = (pageNumber - 1) * limit;
    setSkip(newSkip);
  };

  const TableDataUi = () => {
    return list?.result?.map((row, index) => (
      <TableRow
        key={row.id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.id ? row.id : index + 1}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.name}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography
            fontFamily={"Poppins-Regular"}
            color={Colors.textColor}
            fontSize={12}
          >
            {row.circle_name}
          </Typography>
        </TableCell>

        <TableCell>
          <Switch
            {...label}
            defaultChecked
            color={"error"}
            checked={row?.active === true ? true : false}
            onChange={(e) => {
              if (e?.target) {
                setUpdateStatus({
                  ...updateStatus,
                  open: true,
                  data: {
                    ...row,
                    status: e?.target?.checked ? true : false,
                  },
                  isChecked: e?.target?.checked,
                });
              }
            }}
          />
        </TableCell>
        {/* <TableCell>{row.actions}</TableCell> */}
        <TableCell>
          <Box display={"flex"} gap={"10px"}>
            <Grid>
              <CustomButton
                title={"Delete"}
                width={52}
                height={22}
                fontSize={"12px"}
                backgroundColor={"#E1E1E1"}
                textColor={"#111A45"}
                handleButtonClick={() =>
                  setDelete({
                    open: true,
                    data: row,
                  })
                }
              />
            </Grid>
            <Grid>
              <CustomButton
                title={"Edit"}
                backgroundColor={"#E1E1E1"}
                textColor={"#111A45"}
                width={52}
                height={22}
                fontSize={"12px"}
                handleButtonClick={() => {
                  setIsModalOpen(true);
                  setCurrentList({
                    ...row,
                    open: "edit",
                  });
                }}
              />
            </Grid>
          </Box>
        </TableCell>
      </TableRow>
    ));
  };

  const onClickModalClose = (isFetchRequired) => {
    if (isFetchRequired) {
      getLists();
    }
    setIsModalOpen(false);
  };

  const handleSearchTextChange = (e) => {
    const searchText = e.target.value;
    getLists({ searchText });
  };

  const handleDelete = () => {
    apiRequest({
      url: `master/delete-regional-office/${deleteRec?.data?.id}`,
      method: "DELETE",
    })
      .then((res) => {
        setDelete({
          open: false,
          data: {},
        });
        getLists({ searchString: "" });
      })
      .catch((err) => {});
  };

  const updateRecord = () => {
    apiRequest({
      url: `master/toggle-regional-office/${updateStatus?.data?.id}`,
      method: "PUT",
    })
      .then((res) => {
        setUpdateStatus({
          open: false,
          data: {},
        });
        getLists({ skip, searchText: "" });
      })
      .catch((err) => {});
  };

  useEffect(() => {
    let headers = ["Id,Name,Circle Name,Status"];

    let csv;
    if (Array.isArray(listCSV.data) && listCSV.data.length > 0) {
      csv = listCSV.data?.reduce((acc, elem, index) => {
        const { active, name, circle_name, id } = elem;

        acc.push([id, name, circle_name, active].join(","));
        return acc;
      }, []);

      downloadFile({
        data: [...headers, ...csv].join("\n"),
        fileName: "Regional Office List.csv",
        fileType: "text/csv",
      });
    }
  }, [listCSV]);

  const exportToCsv = () => {
    let payload = {
      skip: skip,
      limit: 100000000,
    };
    apiRequest({
      url: `master/get-regional-office`,
      data: payload,
      method: "GET",
    })
      .then((res) => {
        setListCSV({
          data: res?.data,
        });
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <Box>
      <CustomDialog
        open={isModalOpen}
        onClose={() => onClickModalClose(false)}
        width={"550px"}
        title={currentList?.open === "edit" ? "Edit Regional Office" : "Add Regional Office"}
      >
        <Add
          currentList={currentList}
          onClickModalClose={() => onClickModalClose(false)}
          isEdit={currentList?.name}
          loader={list?.loader}
          getLists={() => getLists({ skip, searchText: "" })}
        />
      </CustomDialog>

      <CustomDialog
        open={openDeleteModal.open}
        onClose={() => setOpenDeleteModal({ open: false })}
        width={"450px"}
        title={"Delete Regional Office"}
      >
        <Box>
          <Typography fontSize={"14px"} fontFamily={"poppins"}>
            Are you sure you want to Delete this Regional Office?
          </Typography>

          <Box
            display={"flex"}
            alignItems={"end"}
            justifyContent={"flex-end"}
            width={"100%"}
            mt={2}
            gap={"12px"}
          >
            <Box width={"25%"}>
              <CustomButton
                variant={"outlined"}
                title={`No`}
                handleButtonClick={() => setOpenDeleteModal({ open: false })}
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
              />
            </Box>
            <Box width={"25%"}>
              <CustomButton
                title={`Yes`}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={handleDelete}
              />
            </Box>
          </Box>
        </Box>
      </CustomDialog>

      {updateStatus.open && (
        <CustomDialog
          title={"Status Confirmation"}
          width={"400px"}
          open={updateStatus.open}
          onClose={() => {
            setUpdateStatus({
              open: false,
              data: {},
            });
          }}
        >
          <Typography>
            Are you sure you want to{" "}
            {updateStatus.data.active == true ? "In-Active" : "Active"}{" "}
            Regional Office
          </Typography>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"flex-end"}
            mt={"24px"}
            gap={"12px"}
          >
            <Grid item>
              <CustomButton
                variant={"outlined"}
                title={`No`}
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={() => setUpdateStatus({ open: false })}
              />
            </Grid>
            <Grid item>
              <CustomButton
                title={`Yes`}
                handleButtonClick={() => updateRecord(updateStatus.open)}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                type={"submit"}
              />
            </Grid>
          </Grid>
        </CustomDialog>
      )}

      {deleteRec.open && (
        <CustomDialog
          title={"Delete Confirmation"}
          width={"400px"}
          open={deleteRec.open}
          onClose={() => {
            setDelete({
              open: false,
              data: {},
            });
          }}
        >
          <Typography>
            Are you sure you want to Delete {deleteRec.data?.animalCategory}{" "}
            Regional Office
          </Typography>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"flex-end"}
            mt={"24px"}
            gap={"12px"}
          >
            <Grid item>
              <CustomButton
                variant={"outlined"}
                title={`No`}
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={() => setDelete({ open: false })}
              />
            </Grid>
            <Grid item>
              <CustomButton
                title={`Yes`}
                handleButtonClick={() => handleDelete(deleteRec.open)}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={"100%"}
                height={34}
                borderColor={Colors.headerColor}
                textFontSize={14}
                type={"submit"}
              />
            </Grid>
          </Grid>
        </CustomDialog>
      )}
      <Grid container justifyContent={"end"}>
        <CustomButton
          title={"Export List"}
          handleButtonClick={() => exportToCsv()}
          backgroundColor={Colors.headerColor}
          textColor={Colors.white}
          textFontSize={14}
          padding={"5px 10px"}
        />
      </Grid>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"space-between"}
        mt={2}
      >
        <Grid item>
          <Typography
            fontFamily={"Poppins-Medium"}
            fontSize={20}
            color={Colors.textColor}
          >
            Regional Offices
          </Typography>
          <Typography
            fontFamily={"Poppins-Regular"}
            fontSize={13}
            color={Colors.textColor}
          >
            Masters Regional Offices
          </Typography>
        </Grid>
        <Grid item sx={{ cursor: "pointer" }}>
          <CustomButton
            title={"+ Add Regional Office"}
            handleButtonClick={() => {
              setIsModalOpen(true);
              setCurrentList({ open: "add" });
            }}
            backgroundColor={Colors.headerColor}
            textColor={Colors.white}
            width={180}
            height={34}
            textFontSize={14}
          />
        </Grid>
      </Grid>

      <Box mt={2}>
        <Card>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item md={3}>
              <CustomInput
                placeholder={"Search"}
                onChange={(e) => handleSearchTextChange(e)}
                leftIcon={
                  <SearchOutlinedIcon style={{ color: Colors.textColor }} />
                }
              />
            </Grid>
          </Grid>
          <Box mt={2}>
            <CustomTable
              headerData={dashboardHeader}
              tableData={list.result}
            >
              <TableDataUi />
            </CustomTable>
            <Box mt={2} display={"flex"} justifyContent={"right"}>
              {list.totalCount > 10 && (
                <Pagination
                  totalCount={list.totalCount}
                  skip={skip}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default View;
